import { useState } from 'react'
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Typography } from '@mui/material'
import { formatarBRL } from '@/lib/formato'
import type { TaxaServicoTotem } from './use-taxa-servico-totem'
import { lime } from '@mui/material/colors'

export default function BotaoTaxaServico({ taxa }: { taxa: TaxaServicoTotem }): JSX.Element | null {
    const [confirmando, setConfirmando] = useState(false)
    const { taxaServico, taxaServicoAnterior, dispensada, podeAlterar, enviando, erro, limparErro } = taxa

    if (!podeAlterar) return null

    const confirmarDispensa = async (): Promise<void> => {
        setConfirmando(false)
        await taxa.dispensar()
    }

    return (
        <>
            <Button
                variant="outlined"
                fullWidth
                disabled={enviando}
                onClick={dispensada ? () => void taxa.reaplicar() : () => setConfirmando(true)}
                startIcon={enviando ? <CircularProgress size={20} color="inherit" /> : undefined}
                sx={{
                    mt: 1,
                    minHeight: 48,
                    textTransform: 'none',
                    color: (theme) => theme.palette.mode === 'dark' ? lime[400] : lime[800],
                    borderColor: (theme) => theme.palette.mode === 'dark' ? lime[400] : lime[800],
                }}
            >
                <Typography variant="body1" sx={{ fontWeight: 600, lineHeight: 1 }}>
                    {dispensada ? `incluir a taxa de serviço${taxaServicoAnterior > 0 ? ` (${formatarBRL(taxaServicoAnterior)})` : ''}` : 'Não quero pagar a taxa de serviço'}
                </Typography>
            </Button >

            <Dialog open={confirmando} onClose={() => setConfirmando(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ fontSize: '1.6rem', fontWeight: 'bold' }}>Retirar a taxa de serviço?</DialogTitle>

                <DialogContent>
                    <Typography variant="h6" color="text.secondary">
                        A taxa de {formatarBRL(taxaServico)} será retirada da sua conta. Você pode voltar a incluí-la a
                        qualquer momento antes de pagar.
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        size="large"
                        onClick={() => setConfirmando(false)}
                        sx={{ minHeight: 56, borderRadius: 2, textTransform: 'none', flex: 1 }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Manter a taxa
                        </Typography>
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => void confirmarDispensa()}
                        sx={{ minHeight: 56, borderRadius: 2, textTransform: 'none', flex: 1 }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Retirar a taxa
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={!!erro}
                autoHideDuration={5000}
                onClose={limparErro}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity="error" variant="filled" onClose={limparErro} sx={{ fontSize: '1.1rem' }}>
                    {erro}
                </Alert>
            </Snackbar>
        </>
    )
}
